import React from 'react';
import PropTypes from 'prop-types';

import './AddCta.scss';

const AddCta = ({ handleClick = () => {}, text = '+add', className = '' }) => (
    <div
        className={`component-Users-UserProfile-Modules-AddCta ${className}`}
        onClick={handleClick}
    >
        {text}
    </div>
);

AddCta.propTypes = {
    /**
     * handler for clicking
     */
    handleClick: PropTypes.func.isRequired,
    /**
     * custom styling to override default
     */
    className: PropTypes.string,
    /**
     * text to be displayed
     */
    text: PropTypes.string,
};

export default AddCta;
